<button type="button" class="btn btn-inverse shadow-sm py-1" (click)="toggle()">
  <i *ngIf="expand" class="fa fa-angle-double-up" ></i>
  <i *ngIf="!expand" class="fa fa-angle-double-down" ></i>
</button>
